import React, { useRef, useState } from "react";
import { fa } from "../core/format";

const OK = ["application/pdf", "image/png", "image/jpeg", "image/webp"];
const sizeText = (b) => (b >= 1048576 ? `${fa((b / 1048576).toFixed(1))} مگابایت` : `${fa(Math.max(1, Math.round(b / 1024)))} کیلوبایت`);
const icon = (t) => (t === "application/pdf" ? "fa-regular fa-file-pdf" : "fa-regular fa-image");

/** انتخاب چندفایله؛ می‌توان چند بار «افزودن فایل» زد. files: آرایه‌ی File */
export default function MultiFileField({ label, required, files = [], onChange, error, hint, max = 10, maxMb = 5 }) {
  const ref = useRef(null);
  const [err, setErr] = useState("");

  const add = (e) => {
    const picked = [...(e.target.files || [])];
    e.target.value = "";
    if (!picked.length) return;
    const next = [...files];
    setErr("");
    for (const f of picked) {
      if (!OK.includes(f.type)) { setErr(`«${f.name}»: فقط PDF یا تصویر (PNG، JPG، WEBP) مجاز است`); continue; }
      if (f.size > maxMb * 1024 * 1024) { setErr(`«${f.name}»: حجم فایل بیش از ${fa(maxMb)} مگابایت است`); continue; }
      if (next.some((x) => x.name === f.name && x.size === f.size && x.lastModified === f.lastModified)) continue;
      if (next.length >= max) { setErr(`حداکثر ${fa(max)} فایل مجاز است`); break; }
      next.push(f);
    }
    onChange(next);
  };

  return (
    <div className="field" style={{ gridColumn: "1 / -1" }}>
      <label>{label}{required && <span className="req">*</span>}</label>
      <div style={{ display: "grid", gap: 8 }}>
        {files.map((f, i) => (
          <div key={`${f.name}-${i}`} style={{ display: "flex", alignItems: "center", gap: 10, border: "1.5px dashed var(--primary)", borderRadius: 10, padding: "8px 12px", background: "var(--primary-soft)" }}>
            <i className={icon(f.type)} style={{ color: "var(--primary)" }} />
            <span style={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={f.name}>{f.name}</span>
            <small className="hint" style={{ margin: 0 }}>{sizeText(f.size)}</small>
            <button type="button" className="icon-btn danger" title="حذف از لیست" onClick={() => onChange(files.filter((_, idx) => idx !== i))}><i className="fa-solid fa-xmark" /></button>
          </div>
        ))}
      </div>
      <div style={{ marginTop: files.length ? 8 : 0 }}>
        <button type="button" className="btn btn-ghost btn-sm" disabled={files.length >= max} onClick={() => ref.current.click()}>
          <i className="fa-solid fa-paperclip" /> {files.length ? "افزودن فایل دیگر" : "انتخاب فایل (چند فایل مجاز است)"}
        </button>
        <input ref={ref} type="file" multiple hidden accept="application/pdf,image/png,image/jpeg,image/webp" onChange={add} />
      </div>
      <div className="hint">{hint || `PDF یا تصویر، تا ${fa(max)} فایل، هر کدام حداکثر ${fa(maxMb)} مگابایت`}</div>
      {(err || error) && <small className="cm-err">{err || error}</small>}
    </div>
  );
}